import React, { useEffect } from "react";
import LandingHeader from "./LandingHeader";
import LandingFooter from "./LandingFooter";
import "./landingPages.css";

const LandingLayout = ({ children, title }) => {
  useEffect(() => {
    document.documentElement.style.fontSize = "100%";

    return () => {
      document.documentElement.style.fontSize = "";
    };
  }, []);
  
  useEffect(() => {
    // Add landing-active class to body when landing page mounts
    document.body.classList.add("landing-active");

    const previousTitle = document.title;
    if (title) {
      document.title = title;
    }

    // Cleanup on unmount
    return () => {
      // Only remove the class if there are no other landing layouts currently mounted
      const activeWrappers = document.querySelectorAll("div.landing-active");
      if (activeWrappers.length <= 1) {
        document.body.classList.remove("landing-active");
      }
      document.title = previousTitle;
    };
  }, [title]);

  return (
    <div className="landing-page-wrapper">
      <LandingHeader />
      <main>{children}</main>
      <LandingFooter />
    </div>
  );
};

export default LandingLayout;
